export const slugify = string =>
  `%1E-${string
    .replace(/&/g, 'and')
    .replace(/ /g, '-')
    .replace(/\//g, '-')}`;
